import { Outlet, Link, useNavigate, router, useParams } from "react-router-dom";
import { useState, useMemo, useEffect, useRef } from "react";
import { AppValues, ApiUrl, API, ApiAdmin, imageDeller } from "../../Values";
import { Modal, Button, Dropdown } from "react-bootstrap";
import axios from "axios";
import Cookies from "js-cookie";
import LoginCheck from "../../LoginCheckAdmin/page";
import Header_ from "../compoenents/Header_";
import {
  Reviews0,
  Reviews1,
  Reviews2,
  Reviews3,
  Reviews4,
  Reviews5,
} from "../../Reviews/page";
export default function AdminDeller() {
  const navigate = useNavigate();

  //---------ShowModal----------------------------
  const [TypeModal, SetTypeModal] = useState("");
  const [ShowModal, SetShowModal] = useState(false);
  const handleCloseModal = () => SetShowModal(false);
  const handleShowModal = () => SetShowModal(true);
  const [Inputs, setInputs] = useState([]);
  const [SearchText, SetSearchText] = useState("");
  const [TextMSG, SetTextMSG] = useState("");
  const [Reviews, SetReviews] = useState("0");

  //===========Check Login ================
  LoginCheck();
  var admininfo = [];

  var AdminName = "";
  var AdminID = "";
  if (Cookies.get("admininfo")) {
    admininfo = JSON.parse(Cookies.get("admininfo"));
    AdminName = admininfo[0].Name;
    AdminID = admininfo[0].ID;
  }
  const [Data, SetData] = useState([]);
  const [DataDeller, SetDataDeller] = useState([]);
  const [DellerName, SetDellerName] = useState("");
  const [DellerID, SetDellerID] = useState("");
  const [DellerMony, SetDellerMony] = useState("");
  const [DellerJob, SetDellerJob] = useState("");

  useEffect(() => {
    GetData();
  }, []);

  const [intervalActive, setIntervalActive] = useState(true);
  const fetchIntervalRef = useRef(null);
  // جلب الرسائل بشكل دوري
  useEffect(() => {

    if (intervalActive) {
      fetchIntervalRef.current = setInterval(() => {
        //  GetData();
      }, 3000);
    }
    return () => clearInterval(fetchIntervalRef.current);
  }, [intervalActive]);

  //Implementing the setInterval method
  // const interval = setInterval(() => {
  //   GetData();
  // }, 20000);
  //-------------------------------------------------------------
  async function GetData() {
    // SetData([]);
    try {
      const post = {
        Action: "AdminDellers",
        SearchText: SearchText,
      };
      console.log(post);
      const response = await fetch(ApiAdmin + "/deller.php", {
        method: "POST",
        body: JSON.stringify(post),
      });
      const data_ = await response.json();
      // console.log(data_);

      const datanew = JSON.stringify(data_);
      const dataold = JSON.stringify(Data);
      // if (datanew.length != dataold.length) {
      // if (Orders.length !== data.length) {
      if (datanew !== dataold) {
        SetData(data_);
      }
    } catch (error) {
      return error;
    }
  }

  //----------------------------------------
  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };
  //----------------------------------------
  const handleTextClear = (e) => {
    const name = e.target.name;
    const value = "";
    setInputs((values) => ({ ...values, [name]: value }));
  };

  //-------------------------------------------------------------
  //-------------------------------------------------------------
  const handleChangeTextMSG = (e) => {
    SetTextMSG(e.target.value);
    console.log(TextMSG);
  };
  const handleTextClearTextMSG = (e) => {
    SetTextMSG("");
  };

  //-------------------------------------------------------------
  async function Active(ID, Name, Statue) {
    var Stat_ = "";
    var Statue_ = "";
    if (Statue == "disable") {
      Statue_ = "enable";
      Stat_ = "تنشيط";
    }
    if (Statue == "Pinding") {
      Statue_ = "enable";
      Stat_ = "تنشيط";
    }
    if (Statue == "enable") {
      Statue_ = "disable";
      Stat_ = "ايقاف";
    }
    try {

      if (window.confirm(`هل تريد  ${Stat_}  ${Name} `)) {
      setIntervalActive(false);
        console.log("=====================================");
        const post = {
          Action: "ActiveDeller",
          ID: ID,
          Name: Name,
          Statue: Statue_
        };
        const response = await fetch(ApiAdmin + "/deller.php", {
          method: "POST",
          body: JSON.stringify(post),
        });
        const data = await response.json();
        console.log(data);
       SetData(data);
        // GetData()

      }
    } catch (error) {
      return error;

    }

  }

  //-------------------------------------------------------------
  async function DeleteDeller(ID, Name) {
    if (window.confirm(`هل تريد حذف  ${Name} `)) {
      handleCloseModal();
      try {
        const post = {
          Action: "Delete",
          ID: ID,
          Name: Name,
        };

        const response = await fetch(ApiAdmin + "/deller.php", {
          method: "POST",
          body: JSON.stringify(post),
        });
        const data = await response.json();
        console.log(data);
      SetData(data);
        // GetData();
      } catch (error) {
        return error;
      }
    }
  }

  //-------------------------------------------------------------
  async function ChangeKobone(ID, Name) {
    setIntervalActive(false);
    SetTypeModal("Kobon");
    SetDellerID(ID);
    SetDellerName(Name);
    handleShowModal();
  }

  //======================================
  //-------------------------------------------------------------
  const [Datakobon, SetDatakobon] = useState([]);

  async function Getkobon(NameID, Name) {
    try {
      setIntervalActive(false);
      ChangeKobone(NameID, Name);
      const post = {
        Action: "GetkobonToName",
        account_type: "مندوب",
        NameID: NameID,
        Name: Name,
      };
      SetDatakobon([]);
      const response = await fetch(ApiAdmin + "/kobon.php", {
        method: "POST",
        body: JSON.stringify(post),
      });
      const data = await response.json();
      console.log(data);
      SetDatakobon(data);
    } catch (error) {
      return error;
    }
  }
  //----------------------
  async function DeleteKobon(ID, Descount, Name, NameID) {
    if (window.confirm(`هل تريد حذف كوبون  ${Name} `)) {
      try {
        setIntervalActive(false);
        const post = {
          Action: "DeleteKobon_",
          ID: ID,
          Descount: Descount,
          account_type: "مندوب",
          NameID: NameID,
          Name: Name,
        };
        const response = await fetch(ApiAdmin + "/kobon.php", {
          method: "POST",
          body: JSON.stringify(post),
        });
        const data = await response.json();
        console.log(data);
        Getkobon(NameID, Name);
        GetData();
        setIntervalActive(true);
      } catch (error) {
        return error;
      }
    }
  }
  //----------------------
  //----------------------
  //----------------------
  const handleSubmitAddKobon = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data_ = Object.fromEntries(formData.entries());
    if (window.confirm(`هل تريد اضافة كوبون  ${DellerName} `)) {
      try {
        const response = await fetch(ApiAdmin + "/kobon.php", {
          method: "POST",
          body: JSON.stringify(data_),
        });
        console.log(response);
        const data = await response.json();
        console.log(data);

        if (data.errors != "") {
          return alert(data.errors);
        }
        if (data.msg != "") {
          console.log(data.msg);
          handleCloseModal();
          // alert("تم اضافة الكوبون");
          GetData();
        }

        if (response.ok) {
        } else if (response.status === 400) {
          return alert("errorr 400");
        } else {
          return alert("can not save ");
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  //----------------------

  //-------------------------------------------------------------
  async function ChangeKhasm(ID, Name) {
    setIntervalActive(false);
    SetTypeModal("Khasm");
    SetDellerID(ID);
    SetDellerName(Name);
    handleShowModal();
  }

  //----------------------
  const handleSubmitKhasm = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data_ = Object.fromEntries(formData.entries());
    if (window.confirm(`هل تريد عمل خصم الى  ${DellerName} `)) {
      try {
        const response = await fetch(ApiAdmin + "/deller.php", {
          method: "POST",
          body: JSON.stringify(data_),
        });

        console.log(response);
        const data = await response.json();
        if (data.errors != "") {
          return alert(data.errors);
        }
        if (data.msg == "Success") {
          console.log(data.msg);
          handleCloseModal();
          GetData();
          setIntervalActive(true);
        }

        if (response.ok) {
        } else if (response.status === 400) {
          return alert("errorr 400");
        } else {
          return alert("can not save ");
        }
      } catch (error) {
        console.log(error);
      }
    }
  };


  //-------------------------------------------------------------
  async function ChangeAlert(ID, Name) {
    setIntervalActive(false);
    SetTypeModal("Alert");
    SetDellerID(ID);
    SetDellerName(Name);
    handleShowModal();
  }

  //----------------------

  //----------------------
  const handleSubmitAlert = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data_ = Object.fromEntries(formData.entries());
    if (window.confirm(`هل تريد ارسال تنبية  ${DellerName} `)) {
      try {
        const response = await fetch(ApiAdmin + "/Alerts.php", {
          method: "POST",
          body: JSON.stringify(data_),
        });
        console.log(response);
        const data = await response.json();
        if (data.errors != "") {
          return alert(data.errors);
        }
        if (data.msg == "Success") {
          console.log(data.msg);
          handleCloseModal();
          setIntervalActive(true);
        }

        if (response.ok) {
        } else if (response.status === 400) {
          return alert("errorr 400");
        } else {
          return alert("can not save ");
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  //===============================================================
  async function ChangeAlertAll(ID, Name) {
    setIntervalActive(false);
    SetTypeModal("AlertAll");
    handleShowModal();
  }
  //-------------------------------------------------------------
  const handleSubmitAlertAll = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data_ = Object.fromEntries(formData.entries());
    if (window.confirm(`هل تريد ارسال تنبية الى كل المندوبين `)) {
      try {
        const response = await fetch(ApiAdmin + "/Alerts.php", {
          method: "POST",
          body: JSON.stringify(data_),
        });
        console.log(response);
        const data = await response.json();
        if (data.errors != "") {
          return alert(data.errors);
        }
        if (data.msg == "Success") {
          console.log(data.msg);
          handleCloseModal();
          setIntervalActive(true);
        }

        if (response.ok) {
        } else if (response.status === 400) {
          return alert("errorr 400");
        } else {
          return alert("can not save ");
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  //======================================================

  //-------------------------------------------------------------
  async function ChangeSubScribe(ID, Name, reviews) {
    setIntervalActive(false);
    SetTypeModal("SubScribe");
    SetDellerID(ID);
    SetDellerName(Name);
    SetReviews(reviews);
    handleShowModal();
  }
  //---------------------------
  async function ChangeSendMony(ID, Name, Mony) {
    SetDellerID(ID);
    SetDellerName(Name);
    SetDellerMony(Mony);
    setIntervalActive(false);
    SetTypeModal("SendMony");
    handleShowModal();
  }

  //---------------------------



  const handleSendMony = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data_ = Object.fromEntries(formData.entries());
    if (window.confirm(`هل تريد اتمام العملية  ${DellerName} `)) {
      try {
        const response = await fetch(ApiAdmin + "/deller.php", {
          method: "POST",
          body: JSON.stringify(data_),
        });
        console.log(response);
        const data = await response.json();
        if (data.errors != "") {
          return alert(data.errors);
        }

        if (data.msg != "") {
          console.log(data.msg);
          handleCloseModal();
          setIntervalActive(true);
          GetData();
        }

        if (response.ok) {
        } else if (response.status === 400) {
          return alert("errorr 400");
        } else {
          return alert("can not save ");
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleSubmiSubScribe = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data_ = Object.fromEntries(formData.entries());
    if (window.confirm(`هل تريد تقييم  ${DellerName} `)) {
      try {
        const response = await fetch(ApiAdmin + "/Reviews.php", {
          method: "POST",
          body: JSON.stringify(data_),
        });
        console.log(response);
        const data = await response.json();
        if (data.errors != "") {
          alert(data.errors);
        }
        if (data.msg != "") {
          console.log(data.msg);
          handleCloseModal();
          setIntervalActive(true);
          GetData();
        }

        if (response.ok) {
        } else if (response.status === 400) {
          return alert("errorr 400");
        } else {
          return alert("can not save ");
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  async function ChangeJob(ID, Name, Job) {
    setIntervalActive(false);
    SetTypeModal("ChangeJob");
    SetDellerID(ID);
    SetDellerName(Name);
    SetDellerJob(Job);
    handleShowModal();
  }


  const handleSubmitJob = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data_ = Object.fromEntries(formData.entries());


    if (window.confirm(`هل تريد  تغيير الوظيفة  ${DellerName} `)) {
      try {
        const response = await fetch(ApiAdmin + "/deller.php", {
          method: "POST",
          body: JSON.stringify(data_),
        });
        console.log(response);
        const data = await response.json();
        if (data.errors != "") {
          return alert(data.errors);
        }
        console.log(data.msg);
        handleCloseModal();
        setIntervalActive(true);
        GetData();
        if (response.ok) {
        } else if (response.status === 400) {
          return alert("errorr 400");
        } else {
          return alert("can not save ");
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  //===============================================================

  //=============================================
  return (
    <>
      <Header_ />
      <div dir="rtl" className="row p-0 m-0 mt-0 text-center">
        <h3 className="text-orange fw-bold py-1">المندوبين  {Data.length}</h3>
        <div className="col-lg-1 pt-2 col-3 my-2 ">
          <Link to={`../DellerNavigationAll`}>
            <i className="fa-solid fa-location-dot text-blue fs-3 ms-2"></i>
          </Link>
          <i
            onClick={() => ChangeAlertAll()}
            className="fa-solid fa-bell  text-info fs-3"
          ></i>

        </div>
        <div className="col-lg-11  col-9 my-2">
          <div className="div-SearchText">
            <input
              type="text"
              name="SearchText"
              className="SearchText"
              onChange={(e) => { SetSearchText(e.target.value) }}
              onClick={(e) => { SetSearchText("") }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  GetData();
                }
              }}
              value={SearchText}
              autoComplete="off"
            // placeholder="بحث برقم تليفون او رقم اوردر او اسم مندوب"
            />
            <button className="btn btn-syan  m-0 me-1" onClick={GetData}>
              Search
            </button>
          </div>
        </div>

        <div className="col-12 mt-0 text-center p-0">
          <div className="table-responsive text-center  m-auto p-0" >

            <table
              dir="rtl"
              className="table table-striped0 table-hover m-auto"
              style={{ minWidth: "1250px" }}
            >
              <thead>
                <tr>
                  <th Width="60px"> الحالة</th>
                  <th width="150px">الاسم</th>
                  <th width="10px">الحساب</th>
                  <th width="140px">العنوان</th>
                  <th width="300px">الموقع الحالى</th>
                  <th width="30px"> العمل</th>
                  <th width="100px">التقييم</th>
                  <th width="50px"> الرصيد</th>
                  <th width="30px"> الاوردرات</th>
                </tr>
              </thead>
              <tbody>
                {Data.length < 1 && (
                  <tr>
                    <td
                      className="text-center fs-6 fw-bold text-danger"
                      colSpan="15"
                    >
                      لا توجد بيانات
                    </td>
                  </tr>
                )}

                {Data.length > 0 &&
                  Data.map((x, index) => {
                    var classStatu = "";
                    var classwarking = "";
                    var Statu = "";
                    var classRassed = "";
                    var mony_ = parseFloat(x.Mony);

                    if (mony_ > 0) {
                      classRassed = "text-green";
                    } else {
                      classRassed = "text-danger";
                    }
                    // ----------------------
                    if (x.Statue == "Active") {
                      classStatu = "text-green";
                    }

                    if (x.Statue != "Active") {
                      classStatu = "text-warning";
                    }
                    if (x.Statue == "enable") {
                      classStatu = "text-green";
                      Statu = "نشط";
                    }
                    if (x.Statue == "disable") {
                      classStatu = "text-danger";
                      Statu = "مغلق";
                    }
                    if (x.Statue == "Pinding") {
                      classStatu = "text-warning";
                      Statu = "انتظار";
                    }

                    //------------------------------------------
                    if (x.warking == "يعمل") {
                      classwarking = "text-green0";
                    }
                    if (x.warking != "يعمل") {
                      classwarking = "text-danger";
                    }

                    //-----------------------------------------
                    return (
                      <tr key={index}>
                        <td className="text-center px-1">
                          <span
                            onClick={() => Active(x.ID, x.Name, x.Statue)}
                            className={`p-0 px-2 w-100 fw-bold0 rounded`}
                          >
                            <i className={`mx-1 fs-6 fw-bold fa-regular fa-id-badge   ${classStatu}`}></i>
                            {Statu}
                          </span>
                        </td>
                        <td onClick={() => ChangeImage(x.ID, x.Name, x)}>
                          {ImageJob(x.job)}
                          <span >{x.Name}</span>
                        </td>
                        <td >{x.ID}</td>


                        {/* <td className="text-end px-1">
                          {x.City + " - " + x.State + " - " + x.Address}

                        </td> */}
                        <td>{x.City + " - " + x.State}</td>
                        <td>{x.locationName}</td>
                        <td className="text-center px-1">
                          <label
                            className={`p-0 w-100 fw-bold0 rounded ${classwarking}`}
                          >
                            {x.warking}
                          </label>
                        </td>

                        <td
                          className="text-center"
                          onClick={() =>
                            ChangeSubScribe(x.ID, x.Name, x.reviews)
                          }
                        >
                          {x.reviews == "0" && <Reviews0 />}
                          {x.reviews == "1" && <Reviews1 />}
                          {x.reviews == "2" && <Reviews2 />}
                          {x.reviews == "3" && <Reviews3 />}
                          {x.reviews == "4" && <Reviews4 />}
                          {x.reviews == "5" && <Reviews5 />}
                        </td>


                        <td className="text-center">
                          <span className={`fw-bold  ${classRassed}`}>
                            {x.Mony}
                          </span>
                        </td>
                        <td className="text-center">{x.orders}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <ModalSHOW />
    </>
  );
  // ================================================

  function ModalSHOW() {
    return (
      <>
        <Modal show={ShowModal} onHide={handleCloseModal}>
          <Modal.Body>
            <h6 className="text-danger p-0 m-0" onClick={handleCloseModal}>
              X
            </h6>
            {TypeModal == "Kobon" && <KobonForm />}
            {TypeModal == "Khasm" && <KhasmForm />}
            {TypeModal == "Alert" && <AlertForm />}
            {TypeModal == "AlertAll" && <AlertFormAll />}
            {TypeModal == "SubScribe" && <SubScribe />}
            {TypeModal == "SendMony" && <SendMony />}
            {TypeModal == "ShowImage" && <ShowImage />}
            {TypeModal == "ChangeJob" && <JobForm />}

          </Modal.Body>
        </Modal>
      </>
    );
  }
  // ================================================


  function ImageJob(job) {
    var pathIMG = "";
    if (job == "سائق سيارة") {
      pathIMG = "/car.png";
    }
    if (job == "سائق متوسيكل") {
      pathIMG = "/motosekl0.png";
    }
    if (job == "نقل ثقيل") {
      pathIMG = "/nkl2.png";
    }
    if (job == "دليفرى") {
      pathIMG = "/delevary.jpg";
    }
    return (<>
      <img src={pathIMG} alt="" style={{ width: "30px", height: "20px" }} />
    </>);

  }

  // ================================================
  //---------------------------
  async function ChangeImage(ID, Name, x) {
    SetDataDeller(x);
    SetDellerID(ID);
    SetDellerName(Name);
    setIntervalActive(false);
    SetTypeModal("ShowImage");
    handleShowModal();
  }
  //=========================================

  function ShowImage() {
    const defaultImage = "/bg111.jpg";
    const [cardError, setCardError] = useState(false);
    const [licenseError, setLicenseError] = useState(false);
    const printRef = useRef(null); // 🔹 مرجع للطباعة
    const [fullScreen, setFullScreen] = useState(false);
    const [licenseFullScreen, setLicenseFullScreen] = useState(false);

    const cardImageUrl = `${imageDeller}${DellerID}/Card${DellerID}.jpg`;
    const licenseImageUrl = `${imageDeller}${DellerID}/Rkhsa${DellerID}.jpg`;

    const downloadImage = (urlImage, filename) => {
      const proxyUrl = `${ApiUrl}/image-proxy.php?url=${encodeURIComponent(urlImage)}`;
      const link = document.createElement('a');
      link.href = proxyUrl;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    const handlePrint = () => {
      const printContent = printRef.current;
      const originalContent = document.body.innerHTML;
      document.body.innerHTML = printContent.innerHTML;
      window.print();
      document.body.innerHTML = originalContent;
      window.location.reload();
    };




    return (
      <>

        <div className="row mt-0 px-1" ref={printRef}>
          <div className="col-12 text-end p-0 mb-0 mt-1">
            <small>الاسم : {DataDeller.Name}</small><br /> <small> الحساب : {DataDeller.ID}</small><br />
            <small>موبايل : {DataDeller.Mobail}</small> -
            <small> بطاقة : {DataDeller.Card}</small><br />
            <small>عنوان : {DataDeller.City + " - " + DataDeller.State + " - " + DataDeller.Address}</small><br />
            <hr />
            <small> {ImageJob(DataDeller.job)}: {DataDeller.CarType}</small>  -
            <small> اللوحات : {DataDeller.LawhatNumber + " " + DataDeller.LawhatLeters}</small><br />
            <small> الرخصة : {DataDeller.RkhsaType}</small>    -
            <small>  مكان العمل : {DataDeller.CityWork}</small><br />
            <hr />
          </div>

          <div className="Hide p-0 m-0">
            {ACTION(DataDeller.ID, DataDeller.Name, DataDeller.reviews, DataDeller.job)}
          </div>

          <div className="col-6 text-center p-1">
            <h6>صورة البطاقة</h6>
            <div className="image-section">
              {/* الصورة داخل الديالوج */}
              <img
                src={cardError ? defaultImage : cardImageUrl}
                alt="صورة البطاقة"
                className="image-print"
                style={{
                  width: '100%',
                  height: '100%',
                  borderRadius: '10px',
                  objectFit: 'cover',
                  backgroundColor: cardError ? '#f0f0f0' : 'transparent',
                  cursor: 'pointer'
                }}
                onClick={() => setFullScreen(true)}
                onError={() => setCardError(true)}
              />

              {/* عرض الصورة بكامل الشاشة عند الضغط */}
              {fullScreen && (
                <div
                  style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    backgroundColor: 'rgba(0,0,0,0.9)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 9999,
                    flexDirection: 'column'
                  }}
                >
                  <img
                    src={cardError ? defaultImage : cardImageUrl}
                    alt="عرض كامل للصورة"
                    style={{
                      maxWidth: '90%',
                      maxHeight: '80%',
                      borderRadius: '10px',
                      objectFit: 'contain'
                    }}
                  />
                  <button
                    onClick={() => setFullScreen(false)}
                    style={{
                      marginTop: '20px',
                      padding: '10px 20px',
                      fontSize: '16px',
                      backgroundColor: '#ff4d4d',
                      color: 'white',
                      border: 'none',
                      borderRadius: '5px',
                      cursor: 'pointer'
                    }}
                  >
                    إغلاق
                  </button>
                </div>
              )}
            </div>
            {/* {!cardError && (
              <button
                className="btn btn-sm btn-success mt-2  Hide"
                onClick={() => downloadImage(cardImageUrl, `Card${DellerID}.jpg`)}
              >
                تحميل صورة البطاقة
              </button>
            )} */}
          </div>

          <div className="col-6 text-center p-1">
            <h6>صورة الرخصة</h6>
            <div className="image-section">
              {/* الصورة داخل الديالوج */}
              <img
                src={licenseError ? defaultImage : licenseImageUrl}
                alt="صورة الرخصة"
                className="image-print"
                style={{
                  width: '100%',
                  height: '100%',
                  borderRadius: '10px',
                  objectFit: 'cover',
                  backgroundColor: licenseError ? '#f0f0f0' : 'transparent',
                  cursor: 'pointer'
                }}
                onClick={() => setLicenseFullScreen(true)}
                onError={() => setLicenseError(true)}
              />

              {/* عرض الصورة بكامل الشاشة */}
              {licenseFullScreen && (
                <div
                  style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    backgroundColor: 'rgba(0,0,0,0.9)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 9999,
                    flexDirection: 'column'
                  }}
                >
                  <img
                    src={licenseError ? defaultImage : licenseImageUrl}
                    alt="عرض كامل لصورة الرخصة"
                    style={{
                      maxWidth: '90%',
                      maxHeight: '80%',
                      borderRadius: '10px',
                      objectFit: 'contain'
                    }}
                  />
                  <button
                    onClick={() => setLicenseFullScreen(false)}
                    style={{
                      marginTop: '20px',
                      padding: '10px 20px',
                      fontSize: '16px',
                      backgroundColor: '#ff4d4d',
                      color: 'white',
                      border: 'none',
                      borderRadius: '5px',
                      cursor: 'pointer'
                    }}
                  >
                    إغلاق
                  </button>
                </div>
              )}
            </div>
            {/* {!licenseError && (
              <button
                className="btn btn-sm btn-success mt-2  Hide"
                onClick={() => downloadImage(licenseImageUrl, `Rkhsa${DellerID}.jpg`)}
              >
                تحميل صورة الرخصة
              </button>
            )} */}
          </div>


        </div>
        <div className="text-center mb-2 mt-4">
          <button className="btn btn-primary" onClick={handlePrint}>
            🖨️ طباعة البيانات
          </button>
        </div>
      </>
    );
  }




  //=================================
  function ACTION(ID, Name, reviews, Job) {
    return (
      <div className="col-12 text-center p-0 m-0">
        <div className="table-responsive0 m-0 bg-info">
          <table
            dir="rtl"
            className="table m-auto m-0"
          >
            <thead>
              <tr>
                <th width="60px">تتبع</th>
                <th width="60px">تنبية</th>
                {admininfo[0].Premision == "admin" && (<>

                  <th width="60px">كوبون</th>
                  <th width="60px">خصم</th>
                  {/* <th width="100px">تقييم</th> */}
                  <th width="60px">الوظيفة</th>
                  <th width="30px">حذف</th>

                </>
                )}

              </tr>
            </thead>
            <tbody>
              <tr >


                <td className="text-center text-green fw-bold">
                  <Link to={`../DellerNavigation/${ID}`}>
                    <i className="fa-solid fa-location-dot text-syan  fs-6 mx-1"></i>
                  </Link>
                </td>
                <td className="text-center text-green fw-bold">
                  <i
                    onClick={() => ChangeAlert(ID, Name)}
                    className="fa-solid fa-bell m-0 p-0 text-orange fs-6"
                  ></i>
                </td>
                {admininfo[0].Premision == "admin" && (<>
                  <td className="text-center">
                    <i className="fa-solid fa-tag text-green fs-6"
                      onClick={() => Getkobon(ID, Name)}></i>
                  </td>
                  <td className="text-center">
                    <i className="fa-solid fa-triangle-exclamation text-danger fs-6 " onClick={() => ChangeKhasm(ID, Name)}></i>
                  </td>

                  <td className="text-center text-green fw-bold">
                    <i
                      onClick={() => ChangeJob(ID, Name, Job)}
                      className="fa-solid fa-building m-0 p-0 text-blue fs-6"
                    ></i>
                  </td>

                  <td
                    className="text-center"
                    onClick={() => DeleteDeller(ID, Name)}
                  >
                    <i className=" text-danger fs-6 fw-bold fa-regular fa-xmark"></i>
                  </td>
                </>
                )}

              </tr>

            </tbody>
          </table>


        </div>
      </div>
    );
  }

  function KobonForm() {
    return (
      <>
        <form method="POST" onSubmit={handleSubmitAddKobon}>
          <input type="hidden" name="Action" value="Add_Kobon" />
          <input type="hidden" name="Name" value={DellerName} />
          <input type="hidden" name="NameID" value={DellerID} />
          <input type="hidden" name="account_type" value="مندوب" />
          <input type="hidden" name="Top" value="0" />
          <div className="row mt-0 px-1">
            <div className="col-12 text-center">
              <h4 className="text-green">اضافة كوبون </h4>
              <h6> الاسم : {DellerName}</h6>
            </div>
            <div className="col-12">
              <label htmlFor=""> قيمةالكوبون</label>
              <input
                type="number"
                name="Descount"
                className="form-control text-center mt-1"
              />
            </div>
            <div className="col-6">
              <label htmlFor=""> انتهاء الصلاحية</label>
              <input type="date" name="Expir" className="form-control mt-1" />
            </div>
            <div className="col-12 text-center mx-2 mt-4 ">
              <button className="btn btn-green fw-bold fs-5 w-100">
                اضافة كوبون
              </button>
            </div>
            <br />
          </div>
        </form>
        {Datakobon.length > 0 && (
          <>
            <h4>الكوبونات السابقة </h4>
            <table className="table" cellspacing="1">
              <thead>
                <tr>
                  <th>الكوبون</th>
                  <th className="text-center">القيمة</th>
                  <th>حذف</th>
                </tr>
              </thead>
              <tbody>
                {Datakobon.map((x, index) => {
                  return (
                    <tr key={index}>
                      <td className=" p-0">{x.Info}</td>
                      <td className="text-center p-0">{x.Descount}</td>
                      <td
                        className="text-center"
                        onClick={() =>
                          DeleteKobon(x.ID, x.Descount, x.Name, x.NameID)
                        }
                      >
                        <i className=" text-danger fs-6 fw-bold fa-regular fa-xmark p-0"></i>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <br />
            <br />
          </>
        )}
        ;
      </>
    );
  }




  //========================================
  function SendMony() {
    return (
      <>
        <form method="POST" onSubmit={handleSendMony}>
          <input type="hidden" name="Name" value={DellerName} />
          <input type="hidden" name="NameID" value={DellerID} />
          <input type="hidden" name="Action" value="SendMony" />
          <input type="hidden" name="account_type" value="مندوب" />
          <div className="row mt-0 px-1">
            <div className="col-12 text-center">
              <i className="fa-brands fa-cc-visa  m-0 p-0 text-warning fs-1 mb-2"></i>

              <h4 className="text-syan"> ارسال نقود للمندوب </h4>
              <h6> الاسم : {DellerName}</h6>
              <h6> الرصيد : {DellerMony}</h6>
            </div>
            <div className="col-12">
              <label htmlFor=""> المبلغ</label>
              <input
                type="number"
                name="Mony"
                className="form-control text-center mt-1"
                autoComplete="off"
              />
            </div>
            <div className="col-12 text-center mx-2 mt-4 ">
              <button className="btn btn-syan fw-bold fs-6 w-100">حفظ</button>
            </div>

            <br />
          </div>
        </form>
      </>
    );
  }
  //========================================
  function KhasmForm() {
    return (
      <>
        <form method="POST" onSubmit={handleSubmitKhasm}>
          <input type="hidden" name="Name" value={DellerName} />
          <input type="hidden" name="NameID" value={DellerID} />
          <input type="hidden" name="Action" value="Khasm_" />
          <input type="hidden" name="account_type" value="مندوب" />
          <div className="row mt-0 px-1">
            <div className="col-12 text-center">
              <h4 className="text-danger"> الخصومات </h4>
              <h6> الاسم : {DellerName}</h6>
            </div>
            <div className="col-6">
              <label htmlFor=""> قيمة الخصم</label>
              <input
                type="number"
                name="Khasm"
                className="form-control text-center mt-1"
                autoComplete="off"
              />
            </div>

            <div className="col-12">
              <label htmlFor=""> سبب الخصم</label>
              <input
                type="text"
                name="AlertText"
                className="form-control text-center mt-1"
                autoComplete="off"
              />
            </div>
            <div className="col-12 text-center mx-2 mt-4 ">
              <button className="btn btn-danger fw-bold fs-6 w-100">
                تنفيذ الخصم
              </button>
            </div>

            <br />
          </div>
        </form>
      </>
    );
  }

  //========================================
  function JobForm() {
    return (
      <>
        <form method="POST" onSubmit={handleSubmitJob}>
          <input type="hidden" name="Name" value={DellerName} />
          <input type="hidden" name="ID" value={DellerID} />
          <input type="hidden" name="Action" value="ReplaseJob" />
          <div className="row mt-0 px-1">
            <div className="col-12 text-center">
              <i className="fa-solid fa-building m-0 p-0 text-blue fs-1 mb-2"></i>
              <h4 className="text-blue">  تغيير الوظيفة </h4>
              <h6> الاسم : {DellerName}</h6>
              <h6> الوظيفة الحالية : {DellerJob}</h6>

            </div>
            <div className="col-lg-12 col-md-12 col-12 col-xm-12">
              <label className="col-form-label "> الخدمة </label>
              <select
                name="job"
                className="form-control"
              >
                <option value=""></option>
                <option value="دليفرى">دليفرى</option>
                <option value="سائق متوسيكل">سائق متوسيكل</option>
                <option value="سائق سيارة">سائق سيارة</option>
                <option value="نقل ثقيل">نقل ثقيل</option>
              </select>
            </div>

            <div className="col-12 text-center mx-2 mt-4 ">
              <button className="btn btn-blue fw-bold fs-6 w-100">
                حفظ
              </button>
            </div>

            <br />
          </div>
        </form>
      </>
    );
  }
  //===============================================================

  function AlertForm() {
    return (
      <>
        <form method="POST" onSubmit={handleSubmitAlert}>
          <input type="hidden" name="Name" value={DellerName} />
          <input type="hidden" name="NameID" value={DellerID} />
          <input type="hidden" name="Action" value="AddAlert" />
          <input type="hidden" name="account_type" value="مندوب" />
          <div className="row mt-0 px-1">
            <div className="col-12 text-center">
              <i className="fa-solid fa-bell m-0 p-0 text-warning fs-1 mb-2"></i>
              <h4 className="text-warning"> ارسال تنبيه </h4>
              <h6> الاسم : {DellerName}</h6>
            </div>
            <div className="col-12">
              <label htmlFor=""> رسالة التنبيه</label>
              <input
                type="text"
                name="AlertText"
                className="form-control text-center mt-1"
                autoComplete="off"
              />
            </div>
            <div className="col-12 text-center mx-2 mt-4 ">
              <button className="btn btn-warning fw-bold fs-6 w-100">
                ارسال التنبية
              </button>
            </div>

            <br />
          </div>
        </form>
      </>
    );
  }
  //========================================
  function AlertFormAll() {
    return (
      <>
        <form method="POST" onSubmit={handleSubmitAlertAll}>
          <input type="hidden" name="Action" value="AddAlertAll" />
          <input type="hidden" name="account_type" value="مندوب" />
          <div className="row mt-0 px-1">
            <div className="col-12 text-center">
              <i className="fa-solid fa-bell m-0 p-0 text-warning fs-1 mb-2"></i>
              <h4 className="text-warning"> ارسال تنبية للمندوبين </h4>
            </div>
            <div className="col-12 mt-2">
              <label htmlFor=""> رسالة التنبيه</label>
              <input
                type="text"
                name="AlertText"
                className="form-control text-center mt-1"
                autoComplete="off"
              />
            </div>
            <div className="col-12 text-center mx-2 mt-4 ">
              <button className="btn btn-warning fw-bold fs-6 w-100">
                ارسال التنبية
              </button>
            </div>

            <br />
          </div>
        </form>
      </>
    );
  }
  //====================================================
  //========================================
  function SubScribe() {
    return (
      <>
        <form method="POST" onSubmit={handleSubmiSubScribe}>
          <input type="hidden" name="account_type" value="مندوب" />
          <input type="hidden" name="Name" value={DellerName} />
          <input type="hidden" name="NameID" value={DellerID} />
          <input type="hidden" name="Action" value="AddReviews" />
          <input type="hidden" name="Reviews" value={Reviews} />
          <div className="row mt-0 px-1">
            <div className="col-12 text-center mb-4">
              <h4 className="text-green"> تقييم المندوبين </h4>
              <h6> الاسم : {DellerName}</h6>

              <h6> التقييم : {Reviews}</h6>
            </div>

            <div className="col-12 text-center">
              <button
                className="btn btn-warning px-2 me-1"
                onClick={() => SetReviews("0")}
              >
                0
              </button>
              <button
                className="btn btn-warning px-2 me-1"
                onClick={() => SetReviews("1")}
              >
                1
              </button>
              <button
                className="btn btn-warning px-2 me-1"
                onClick={() => SetReviews("2")}
              >
                2
              </button>
              <button
                className="btn btn-warning px-2 me-1"
                onClick={() => SetReviews("3")}
              >
                3
              </button>
              <button
                className="btn btn-warning px-2 me-1"
                onClick={() => SetReviews("4")}
              >
                4
              </button>
              <button
                className="btn btn-warning px-2 me-1"
                onClick={() => SetReviews("5")}
              >
                5
              </button>
            </div>
            <div className="col-12 text-center mx-2 mt-4 ">
              <button className="btn btn-danger fw-bold fs-6 w-100">
                تقييم
              </button>
            </div>

            <br />
          </div>
        </form>
      </>
    );
  }
  //==================================================
}
